<script>
    export let messages = []
</script>

<div class="px-12 py-10 leading-relaxed message text-left font-light">
    <span style="font-size: 3rem;">Notification</span>

    {#each messages as msg, index}
        {#if index === 0}
            <div class="mt-8 text-lg">{@html msg.message}</div>
        {:else}
            <div class="mt-8 pt-8 text-lg" style="border-top: 1px solid #777777;">{@html msg.message}</div>
        {/if}
    {/each}
</div>

<style>
    .message{
        background: #F6F987;
        border: 1px solid #F6F987;
        box-shadow: 10px 10px 4px rgba(0, 0, 0, 0.25);
        border-radius: 4px;
    }
</style>